import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Settings/CompanyUsers'

export const PROFILES_REQUEST_ASYNC = createAsyncTypes('PROFILES_REQUEST', typeKey)
export const COMPANY_USERS_REQUEST_ASYNC = createAsyncTypes('COMPANY_USERS_REQUEST', typeKey)
export const DELETE_USER_REQUEST_ASYNC = createAsyncTypes('DELETE_USER_REQUEST', typeKey)
export const ADD_USER_REQUEST_ASYNC = createAsyncTypes('ADD_USER_REQUEST', typeKey)
export const UPDATE_USER_REQUEST_ASYNC = createAsyncTypes('UPDATE_USER_REQUEST', typeKey)
export const MAKE_OWNER_ASYNC = createAsyncTypes('MAKE_OWNER', typeKey)
export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', typeKey)
export const CNC_ACCESS_REQUEST_ASYNC = createAsyncTypes('CNC_ACCESS', typeKey)
export const UPDATE_CNC_ACCESS_REQUEST_ASYNC = createAsyncTypes('UPDATE_CNC_ACCESS', typeKey)
export const GET_MANAGEABLE_COMPANIES_ASYNC = createAsyncTypes('GET_MANAGEABLE_COMPANIES', typeKey)
export const GET_USER_INFO_ASYNC = createAsyncTypes('GET_USER_INFO', typeKey)
export const GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC = createAsyncTypes(
  'GET_USER_MANAGEABLE_ASSIGN_COMPANIES',
  typeKey
)
export const GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC = createAsyncTypes(
  'GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES',
  typeKey
)
export const ASSIGN_COMPANIES_ASYNC = createAsyncTypes('ASSIGN_COMPANIES', typeKey)
export const UNASSIGN_COMPANIES_ASYNC = createAsyncTypes('UNASSIGN_COMPANIES', typeKey)

export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const FILTER_SEARCH_CHANGE = `${typeKey}/FILTER_SEARCH_CHANGE`
export const FILTER_SEARCH_RESET = `${typeKey}/FILTER_SEARCH_RESET`
export const ROLE_FILTER_CHANGE = `${typeKey}/ROLE_FILTER_CHANGE`
export const CHANGE_MSP_ROLE_FILTER = `${typeKey}/CHANGE_MSP_ROLE_FILTER`
export const SET_ASSIGNED_COMPANIES_FILTER = `${typeKey}/SET_ASSIGNED_COMPANIES_FILTER`
export const SET_ASSIGNED_COMPANIES_FILTER_PAGE = `${typeKey}/SET_ASSIGNED_COMPANIES_FILTER_PAGE`
export const RESET_USERS = `${typeKey}/RESET_USERS`
export const CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER = `${typeKey}/CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER`
export const CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER = `${typeKey}/CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER`
export const CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER = `${typeKey}/CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER`
export const CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER = `${typeKey}/CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER`
export const SET_USER_ASSIGNED_COMPANIES_PAGE = `${typeKey}/SET_USER_ASSIGNED_COMPANIES_PAGE`
export const SET_TO_ASSIGN_COMPANIES_PAGE = `${typeKey}/SET_TO_ASSIGN_COMPANIES_PAGE`
export const CHANGE_TO_ASSIGN_SELECTION_DATA = `${typeKey}/CHANGE_TO_ASSIGN_SELECTION_DATA`
export const CHANGE_ASSIGNED_SELECTION_DATA = `${typeKey}/CHANGE_ASSIGNED_SELECTION_DATA`
export const SET_TO_ASSIGN_DRAWER_OPEN = `${typeKey}/SET_TO_ASSIGN_DRAWER_OPEN`
export const CHANGE_ALLOWED_MSP_ROLE_ID_FILTER = `${typeKey}/CHANGE_ALLOWED_MSP_ROLE_ID_FILTER`
export const CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER = `${typeKey}/CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER`
export const RESET_TO_ASSIGN_SELECTION_DATA = `${typeKey}/RESET_TO_ASSIGN_SELECTION_DATA`
export const RESET_ASSIGNED_SELECTION_DATA = `${typeKey}/RESET_ASSIGNED_SELECTION_DATA`

export const ASSIGNED_COMPANIES_PER_PAGE = 20
export const ASSIGNED_USER_COMPANIES_PER_PAGE = 50

export const USER_TYPES = {
  REGULAR: 1,
  PARTNER: 2,
  MULTI_PARTNER: 3,
}
